var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChoose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12744 3.36694H20.9419V5.48906H3.12744V3.36694Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45801 0H18.6181V1.76837H5.45801V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.814453 7.61102V19.7559C0.814453 20.8814 1.26162 21.961 2.05748 22.7569C2.85334 23.5527 3.93282 23.9999 5.05847 23.9999H18.9575C20.0832 23.9999 21.1626 23.5527 21.9585 22.7569C22.7543 21.961 23.2015 20.8814 23.2015 19.7559V7.61102H0.814453ZM12.1317 19.2819H12.1316C11.6161 19.7985 10.9164 20.0888 10.1864 20.0888C9.45669 20.0888 8.75674 19.7985 8.24126 19.2819L5.9283 16.976L7.42779 15.4765L9.74074 17.7894C9.86011 17.9083 10.0217 17.9749 10.1899 17.9749C10.3583 17.9749 10.5199 17.9083 10.639 17.7894L16.5876 11.8336L18.0871 13.3331L12.1317 19.2819Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoose);
export default __webpack_public_path__ + "static/media/Choose.c90191b7b824d5f93d441ade958ce03e.svg";
export { ForwardRef as ReactComponent };